import React from 'react'
import {defineMessages, useIntl} from 'react-intl'
import {css} from '@emotion/react'
import styled from '@emotion/styled'
import {MeasurementSystemType} from 'types/Localization'

import {Grid} from '@daedalus/atlas/helpers/Grid'
import {Icon} from '@daedalus/atlas/Icon'

import {convertKmToMiles} from '../utils'

export const messages = defineMessages({
  distanceAsMiles: {
    id: 'distanceAsMiles',
    defaultMessage: 'miles'
  },
  distanceAsKm: {
    id: 'distanceAsKm',
    defaultMessage: 'km'
  },
  distanceFromCityCenter: {
    id: 'distanceFromCityCenter',
    defaultMessage: '{distance} {unit} from {targetName} center'
  }
})

export const DistanceToWrapper = styled.div(
  ({theme}) => css`
    padding-top: ${theme.layout.spacing.s200}px;
  `
)

interface LocationDetailsProps {
  address: string
  cityName?: string
  distanceUnit: MeasurementSystemType
  /** Distance in meters from city center */
  distance: number
}

export const LocationWrapper = styled(Grid)(
  ({theme}) => css`
    color: ${theme.colors.content.neutral.c600};
  `
)
export const NameWrapper = styled.div(
  ({theme}) => css`
    ${theme.typography.text.bodyXS}
  `
)

export const DistanceWrapper = styled(Grid)(
  ({theme}) => css`
    color: ${theme.colors.content.neutral.c600};
  `
)

export const MessageWrapper = styled.div(
  ({theme}) => css`
    ${theme.typography.text.bodyXS};
  `
)

export const LocationDetails = ({
  distance,
  address,
  cityName,
  distanceUnit = 'metric'
}: LocationDetailsProps) => {
  const {formatMessage} = useIntl()

  // Show nothing when distance or message not provided
  if (!distance && !address) return null

  const distanceInKm = distance / 1000
  const [unitMessage, convertedDistance] =
    distanceUnit === 'metric'
      ? [messages.distanceAsKm, distanceInKm]
      : [messages.distanceAsMiles, convertKmToMiles(distanceInKm)]

  const formattedDistance = convertedDistance.toFixed(1)

  const distanceMessage =
    Number(formattedDistance) > 0 && cityName
      ? formatMessage(messages.distanceFromCityCenter, {
          distance: formattedDistance,
          unit: formatMessage(unitMessage),
          targetName: cityName
        })
      : ''

  return (
    <div>
      {address && (
        <div>
          <LocationWrapper
            container
            justify="flex-start"
            alignItems="flex-start"
            spacing="s000"
          >
            <Icon name="Pin" size="sm" />
            <NameWrapper>{address}</NameWrapper>
          </LocationWrapper>
        </div>
      )}

      {distanceMessage && (
        <DistanceToWrapper>
          <DistanceWrapper
            container
            alignItems="flex-start"
            justify="flex-start"
            spacing="s000"
          >
            <Icon name="Walk" size="sm" />
            <MessageWrapper>{distanceMessage}</MessageWrapper>
          </DistanceWrapper>
        </DistanceToWrapper>
      )}
    </div>
  )
}
